// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { DataCache } from "../DataCache.js";
import { Instrument } from "./Instrument.js";
import { Route } from "./Route.js"

export let RouteUtils = function () { };

RouteUtils.findRouteForSources = function (instrument)
{
    if (!Instrument.IsWorkingInstrument(instrument))
        return null

    let symbolRouteName = instrument.getRoute()
    let dc = DataCache
    let route = dc.getRouteByName(symbolRouteName)

    /* TODO.
    if (!route)
        route = dc.getInfoRouteByName(symbolRouteName)
    else
    */
    if (route)
        route = dc.getRouteById(route.QuoteRouteId)

    return route
}

RouteUtils.isSeparatedSourceMode = function (instrument)
{
    if (!instrument)
        return false

    let route = RouteUtils.findRouteForSources(instrument)

    return route && route.ShowMode === Route.ClientShowMode.BuyerSeller
}